import React from "react";

import { CircularProgress } from "@mui/material";
import colors from "../../theme";

const Loader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: colors.mainContentBgColor,
      }}
    >
      <CircularProgress color="success" />
    </div>
  );
};

export default Loader;
